module.exports = __webpack_public_path__ + "static/MuseoSans-700-e8eed9d7915b0f9c78058343a2b83364.woff2";